import { render, staticRenderFns } from "./plan_page.vue?vue&type=template&id=80b7a1fa&scoped=true"
import script from "./plan_page.vue?vue&type=script&lang=js"
export * from "./plan_page.vue?vue&type=script&lang=js"
import style0 from "./plan_page.vue?vue&type=style&index=0&id=80b7a1fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b7a1fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80b7a1fa')) {
      api.createRecord('80b7a1fa', component.options)
    } else {
      api.reload('80b7a1fa', component.options)
    }
    module.hot.accept("./plan_page.vue?vue&type=template&id=80b7a1fa&scoped=true", function () {
      api.rerender('80b7a1fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grow/plan_page.vue"
export default component.exports